import React from 'react';

import { Control } from '@vlabs/uikit';
import type { ButtonProps } from '@vlabs/uikit/components/controls/button/Button';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { useGetCardsCount } from '@vlabs/api/artemy/client';

import st from './ShowCardsCountButton.module.sass';
import type { ListId } from '@vlabs/api/luna-api/model';

interface ShowCardsInListProps extends ButtonProps {
  listId: ListId;
}

export function ShowCardsCountButtonPoint3({
  listId,
  className = undefined,
  ...buttonProps
}: ShowCardsInListProps): React.JSX.Element {
  const { t } = useTranslation();
  const getCardCount = useGetCardsCount({ list_ids: [listId] }, {
    query: {
      enabled: false,
      throwOnError: () => {
        toast.error(t('features:show_cards_count.toast.error'), {
          toastId: listId,
        });
        return false;
      },
    },
  });

  if (getCardCount.isFetched) {
    return (
      <div className={cn(st.Root, className)}>
        <span className={st.Count}>{getCardCount.data?.card_count ?? 0}</span>
      </div>
    );
  }

  return (
    <div className={cn(st.Root, className)}>
      <Control.Button
        disabled={!listId}
        isLoading={getCardCount.isLoading}
        onClick={async () => getCardCount.refetch({})}
        size="small"
        variant="dimmed"
        {...buttonProps}
      >
        {t('features:show_cards_count.button.title')}
      </Control.Button>
    </div>
  );
}
